<template>
  <div 
    :id="$attrs._id"
    class="tag-box"
    :class="{ 
      'tag-box--easty': directionIsEasty,
      'tag-box--southy': directionIsSouthy
    }"
    :style="styles"
  >
    <div class="tag-box__arrow-col">
      <fa :style="arrowStyle" :icon="'arrow-up'" />
    </div>
    <div class="tag-box__content-col">
      <div class="tag-box__label" v-html="label[lang]"></div>
      <div class="tab-box__distance"><fa class="tag-box__car" :icon="['fad', faIcon]"/><span v-html="distance[lang]"></span></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['pos', 'label', 'distance', 'arrowDeg', 'icon', 'lang', 'dir'],
 
  computed: {
    arrowStyle () {
      return { transform: `rotate(${this.arrowDeg}deg)` }
    },

    directionIsEasty () {
      return this.arrowDeg > 0 && this.arrowDeg < 180
    },

    directionIsSouthy () {
      return this.arrowDeg > 90 && this.arrowDeg < 270
    },

    faIcon () {
      return this.icon || 'car'
    },

    styles () {
      return {
        // divide by font size
        left: `${(this.pos.x / 20) / 1.3}em`,
        top: `${(this.pos.y / 20) / 1.3}em`,
      }
    }
  },
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.tag-box {
  background-color: $box-tag-bg-color;
  border-radius: $box-tag-border-radius;
  box-shadow: $tag-box-shadow;
  color: $white;
  display: flex;
  font-family: $touchscreen-font;
  font-size: $box-tag-font-size;
  letter-spacing: .05em;
  line-height: 1.2em;
  padding: 1em 0.5em;  
  position: absolute;
  z-index: 5;

  .ar & {
    font-family: 'GE Dinkum';
  }    

  * {
    pointer-events: none;
    user-select: none;
  }

  &--easty {
    flex-direction: row-reverse;

    .tag-box__content-col {
    }
  }

  &--southy {
    .tag-box__arrow-col {
      align-items: flex-end;
    }
  }

  &__arrow-col {
    display: flex;
    flex-shrink: 0;
    padding: 0;
    width: calc(3em / 1.3);
    justify-content: center;
  }

  &__content-col {
    display: flex;
    flex-direction: column;
    padding: 0 calc(0.5em / 1.3);
  }

  &__label {
    margin-bottom: 0.6em;
  }

  &__car {
    margin-right: 0.6em;
  }
}
</style>
